import { ProductsComponent } from '../components/products/products.component';
import { FileDetailComponent } from './../components/files/file-detail.component';
import { FileBrowseComponent } from './../shared/components/browse/file-browse.component';
import { EntityBrowseComponent } from './../shared/components/browse/entity-browse.component';
import { ConfirmationComponent } from './../shared/components/modal/confirmation/confirmation.component';
import { AuthGuard } from './../shared/guards/auth.guard';
import { ProductDetailComponent } from '../components/products/product-detail.component';
import { ProductCategoryDetailComponent } from '../components/products/product-category-detail.component';
import { TestimonialDetailComponent } from '../components/products/testimonial-detail.component';

export const productsRoutes = {
    path: 'products',
    data: {
        breadcrumbs: {
            label: 'Produkty',
            icon: 'box'
        },
        state: 'products'
    },
    children: [
        {
            path: '',
            component: ProductsComponent
        },
        {
            path: 'products/add',
            data: {
                breadcrumbs: {
                    label: 'Přidat produkt'
                },
                state: 'product-add'
            },
            children: [
                {
                    path: '',
                    component: ProductDetailComponent
                },
                {
                    path: 'file/:id',
                    component: FileDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Upravit soubor'
                        },
                        state: 'products-media-edit'
                    },
                    outlet: 'modal'
                },
                {
                    path: 'files',
                    component: FileBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat soubor'
                        },
                        state: 'products-media-browse'
                    },
                    outlet: 'browse'
                },
                {
                    path: 'entities/:url/:single',
                    component: EntityBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat'
                        },
                        state: 'products-entities-browse'
                    },
                    outlet: 'browse'
                }
            ]
        },
        {
            path: 'categories/add',
            data: {
                breadcrumbs: {
                    label: 'Přidat kategorii'
                },
                state: 'product-category-add'
            },
            children: [
                {
                    path: '',
                    component: ProductCategoryDetailComponent
                },
                {
                    path: 'entities/:url/:single',
                    component: EntityBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat'
                        },
                        state: 'product-cats-entities-browse'
                    },
                    outlet: 'browse'
                }
            ]
        },
        {
            path: 'testimonials/add',
            data: {
                breadcrumbs: {
                    label: 'Přidat referenci'
                },
                state: 'testimonial-add'
            },
            children: [
                {
                    path: '',
                    component: TestimonialDetailComponent
                },
                {
                    path: 'file/:id',
                    component: FileDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Upravit soubor'
                        },
                        state: 'products-media-edit'
                    },
                    outlet: 'modal'
                }
            ]
        },
        {
            path: 'products/edit/:id',
            data: {
                breadcrumbs: {
                    label: 'Upravit produkt'
                },
                state: 'product-edit'
            },
            children: [
                {
                    path: '',
                    component: ProductDetailComponent
                },
                {
                    path: 'file/:id',
                    component: FileDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Upravit soubor'
                        },
                        state: 'products-media-edit'
                    },
                    outlet: 'modal'
                },
                {
                    path: 'files',
                    component: FileBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat soubor'
                        },
                        state: 'products-media-browse'
                    },
                    outlet: 'browse'
                },
                {
                    path: 'entities/:url/:single',
                    component: EntityBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat'
                        },
                        state: 'products-entities-browse'
                    },
                    outlet: 'browse'
                },
                {
                    path: 'testimonials',
                    component: TestimonialDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Přidat referenci'
                        },
                        state: 'product-testimonials-add'
                    },
                    outlet: 'modal-form'
                }
            ]
        },
        {
            path: 'categories/edit/:id',
            data: {
                breadcrumbs: {
                    label: 'Upravit kategorii'
                },
                state: 'category-edit'
            },
            children: [
                {
                    path: '',
                    component: ProductCategoryDetailComponent
                },
                {
                    path: 'entities/:url/:single',
                    component: EntityBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat'
                        },
                        state: 'product-cats-entities-browse'
                    },
                    outlet: 'browse'
                }
            ]
        },
        {
            path: 'testimonials/edit/:id',
            data: {
                breadcrumbs: {
                    label: 'Upravit referenci'
                },
                state: 'testimonial-edit'
            },
            children: [
                {
                    path: '',
                    component: TestimonialDetailComponent
                },
                {
                    path: 'file/:id',
                    component: FileDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Upravit soubor'
                        },
                        state: 'products-media-edit'
                    },
                    outlet: 'modal'
                }
            ]
        },
        {
            path: 'products-delete/:id',
            component: ConfirmationComponent,
            data: {
                breadcrumbs: {
                    label: 'Smazat produkt'
                },
                state: 'products-delete',
                apiUri: 'products'
            },
            outlet: 'modal'
        },
        {
            path: 'categories-delete/:id',
            component: ConfirmationComponent,
            data: {
                breadcrumbs: {
                    label: 'Smazat kategorii'
                },
                state: 'product-category-delete',
                apiUri: 'product-categories'
            },
            outlet: 'modal'
        },
        {
            path: 'testimonials-delete/:id',
            component: ConfirmationComponent,
            data: {
                breadcrumbs: {
                    label: 'Smazat referenci'
                },
                state: 'testimonial-delete',
                apiUri: 'testimonials'
            },
            outlet: 'modal'
        }
    ],
    canActivate: [AuthGuard]
};
